/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SessionSchemaStatus = typeof SessionSchemaStatus[keyof typeof SessionSchemaStatus];


export const SessionSchemaStatus = {
  draft: 'draft',
  running: 'running',
  ready: 'ready',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;
